import { observer } from 'mobx-react';
import React from 'react';
import { IItemBranchesConfig } from '../types/itemBranchesConfig';
import RowWithSize from './RowWithSize';
import RowWithoutSize from './RowWithoutSize';

export interface IRowProps {
  config: IItemBranchesConfig;
  isSize: boolean;
}

const ItemBranchesConfigurationRow: React.FC<IRowProps> = observer((props: IRowProps): JSX.Element | null => {
  const { config, isSize } = props;

  if (isSize) {
    return (
      <div className="border-bottom">
        {config.branch_item_sizes?.map((size, sizeIndex) => (
          <RowWithSize key={size.item_size_id} config={config} size={size} isFirst={sizeIndex === 0} />
        ))}
      </div>
    );
  }

  return (
    <div className="border-bottom">
      <RowWithoutSize config={config} />
    </div>
  );
});

export default ItemBranchesConfigurationRow;
